import http from './axiosInstance'
import errorHandler from '../transformers/axiosErrors'
import { ApiResponse, ExcludeSkillDto } from '@/types'

export const fetchExcludedSkills = async (): Promise<ApiResponse> => {
  const resp: ApiResponse = { data: null, error: null }
  try {
    const response = await http.get('/excluded')
    resp.data = response.data.data
  } catch (e: any) {
    resp.error = e.isAxiosError ? errorHandler(e) : e
  }
  return resp
}

export const excludeSkill = async (
  skill: ExcludeSkillDto
): Promise<ApiResponse> => {
  const resp: ApiResponse = { data: null, error: null }
  try {
    const response = await http.post('/excluded', skill)
    resp.data = response.data
  } catch (e: any) {
    resp.error = e.isAxiosError ? errorHandler(e) : e
  }
  return resp
}

export const includeSkill = async (id: number): Promise<ApiResponse> => {
  const resp: ApiResponse = { data: null, error: null }
  try {
    const response = await http.delete('/excluded/' + id)
    resp.data = response.data
  } catch (e: any) {
    resp.error = e.isAxiosError ? errorHandler(e) : e
  }
  return resp
}

export const includeUserSkill = async (
  opportunityId: number,
  skillName: string
): Promise<ApiResponse> => {
  const resp: ApiResponse = { data: null, error: null }
  try {
    const response = await http.delete(
      `/excluded/opportunities/${opportunityId}/skill/${skillName}`
    )
    resp.data = response.data
  } catch (e: any) {
    resp.error = e.isAxiosError ? errorHandler(e) : e
  }
  return resp
}
